<template>
  <div class="plc-videoEmbed">
    <div class="plc-videoEmbed__container">
      <iframe
        :src="generateURL"
        class="plc-videoEmbed__iframe"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      />
      <div class="plc-videoEmbed__coverChannel" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlVideoEmbed',
  props: {
    url: {
      type: String,
      required: true,
    },
    noCookie: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    generateURL() {
      const video = /\d{1,}/g.exec(this.url)[0]
      return `https://player.vimeo.com/video/${video}?title=0&byline=0&portrait=0`
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-videoEmbed {
  &__container {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
  }

  &__iframe {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &__coverChannel {
    height: 60px;
    position: relative;
    width: 70%;
  }
}
</style>
